export default {
  drawerTitle: {
    id: 'bo_seller-options-shipping-category_details_drawer-title',
    defaultMessage: 'Full list',
  },
} as const
